import { types } from "../types/types";

export const startLineChart = (data) =>{
    return (distpach) =>{
        distpach(lineChart(data))
    }
}

export const lineChart = (data) => ({
    type: types.dataLineChart,
    payload:{
        data
    }
}) 



export const startDonutChart = (data) =>{
    return (distpach) =>{
        distpach(lineChart(data))
    }
}

export const donutChart = (data) => ({
    type: types.dataDonutChart,
    payload:{
        data
    }
})

